'use client';

import { useRouter } from '@bprogress/next/app';
import { useSelector } from '@xstate/store/react';
import { useRef } from 'react';

import {
  GTMEcommerceItem,
  sendGTMEventEcommerce,
  GTMItemListName,
  GTMViewItemList
} from '@/fo/api/gtm';
import {
  cartActions,
  selectCountProductInCart,
  storeProduct
} from '@/fo/store/product';
import { Product, UiProductTileMini } from '@/fo/ui/product/tile/mini';

export interface FeatureProductTileMiniProps {
  data: Product;
  listName: GTMItemListName;
  positionIndex: number;
}

export function FeatureProductTileMini({
  data,
  listName,
  positionIndex
}: FeatureProductTileMiniProps) {
  const ref = useRef<HTMLDivElement>(null);
  const router = useRouter();

  const cartCount = useSelector(
    storeProduct,
    selectCountProductInCart(String(data.id))
  );

  const isInCart = cartCount > 0;

  const onCartClick = () => {
    if (isInCart) {
      router.push('/cart');
    } else {
      cartActions.addProductsToCart([
        {
          sku: String(data.id),
          quantity: 1,
          product: {
            sku: String(data.id),
            name: data.title,
            brand: data.brand ?? '',
            series: data.series ?? '',
            volume: data.volume ?? '',
            basePrice: data.prices?.price ?? null,
            finalPrice: data.prices?.price ?? null,
            baseImage: {
              src: data.image,
              alt: data.alt
            }
          }
        }
      ]);
    }
  };

  const itemGtmData: GTMEcommerceItem = {
    item_id: String(data.id),
    item_name: data.title,
    price: String(data.prices?.price),
    item_brand: data.brand ?? '',
    item_category: data.series || data.brand || '',
    variant: data.volume ?? '',
    position: positionIndex + 1,
    item_list_name: listName
  };

  const onClick = () => {
    sendGTMEventEcommerce({
      event: 'select_item',
      ecommerce: {
        items: [itemGtmData]
      }
    });
  };

  return (
    <>
      <GTMViewItemList
        key={`gtm-${data.id}`}
        refItem={ref}
        item={itemGtmData}
      />
      <UiProductTileMini
        ref={ref}
        key={`ui-${data.id}`}
        product={data}
        onClick={onClick}
        onAddToCart={onCartClick}
        isInCart={isInCart}
      />
    </>
  );
}
